module.exports = __webpack_public_path__ + "static/media/Macbook2.0f94f148.png";